import {Navigate} from "react-router-dom";
import Register from "../pages/Auth/Register";
import OnePage from "../pages/Main";
import Fact from "../pages/Services/Fact";
import Api from "../pages/Services/Api";
import Bot from "../pages/Services/Bot";
import Controll from "../pages/Services/Controll";
import Face from "../pages/Services/Face";
import Salary from "../pages/Services/Salary";
import Table from "../pages/Services/Table";
import Tasks from "../pages/Services/Tasks";
import AboutUs from "../pages/AboutUs";
import Clinics from "../pages/Clinics";
import Support from "../pages/Support";

import InnerLayout from "../Layouts/InnerLayout";
import MainLayout from "../Layouts";

const publicRoutes = [
    {path: "/register", component: <Register/>, layout: MainLayout},

    {path: "/", component: <OnePage/>, layout: MainLayout},
    {path: "/about-us", component: <AboutUs/>, layout: MainLayout},
    {path: "/clinics", component: <Clinics/>, layout: MainLayout},
    {path: "/support", component: <Support/>, layout: MainLayout},

    {path: "/home", component: <OnePage/>, layout: MainLayout},
    {path: "/services/fact", component: <Fact/>, layout: InnerLayout},
    {path: "/services/table", component: <Table/>, layout: InnerLayout},
    {path: "/services/tasks", component: <Tasks/>, layout: InnerLayout},
    {path: "/services/control", component: <Controll/>, layout: InnerLayout},
    {path: "/services/face", component: <Face/>, layout: InnerLayout},
    {path: "/services/bot", component: <Bot/>, layout: InnerLayout},
    {path: "/services/api", component: <Api/>, layout: InnerLayout},
    {path: "/services/salary", component: <Salary/>, layout: InnerLayout},

    {path: "*", component: () => <Navigate to="/home"/>}, // fallback route
];

export {publicRoutes};
